import api from "./index"
export const BlogApi = (params) => api.post("bloglist", params);
export const BlogDetailsApi = (params) => api.post("blogdetails", params);